// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__zjjYJ","menuItem":"styles_menuItem__NLwqm","menuLink":"styles_menuLink__Nt0Xt","activeLink":"styles_activeLink__EsaIy"};